import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

class SearchJobsPlaceHolder extends Component {
  render() {
    const placeholderResults = (n) => {
      const placeholders = [];
      for (let i = 0; i < n; i++) {
        placeholders.push(
          <Row key={i}>
            <Col md={12}>
              <Col xs={6}>
                <div className='job-result-placeholder' style={{ width: '40%' }} />
                <div className='job-result-placeholder' style={{ width: '30%' }} />
                <div className='job-result-placeholder' style={{ width: '50%' }} />
              </Col>
              <Col xs={6} style={{ textAlign: 'right' }}>
                <div className='job-result-placeholder' style={{ width: '25%', float: 'right' }} />
                <br />
                <br />
              </Col>
              <Col xs={12}>
                <hr style={{ marginTop: 0, marginBottom: '5px' }} />
              </Col>
            </Col>
          </Row>
        );
      }
      return placeholders;
    };

    return (
      <div
        className={'job-search-results placeholder'}
        style={{
          position: 'absolute',
          backgroundColor: '#FFF',
          boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
          border: '1px solid #CCC',
          borderRadius: 3,
          marginLeft: '15px',
          marginRight: '15px',
          marginTop: '57px',
          padding: 10,
          zIndex: 999,
          width: '98%',
          maxHeight: '500px',
          overflowY: 'scroll',
          overflowX: 'hidden',
          textAlign: 'center'
        }}
      >
        { placeholderResults(5) }
        <Row>
            <Col xs={6} className="text-left">
              <Button 
                className='show-more-jobs' 
                disabled 
              >
                Prev Page
              </Button>
            </Col>
            <Col xs={6} className='text-right'>
              <Button 
                className='show-more-jobs' 
                disabled 
              >
                Next Page
              </Button>
            </Col>
          </Row>
      </div>
    );
  }
}

export default SearchJobsPlaceHolder;
